import NiceModal from "@ebay/nice-modal-react";
import { requester } from "App";
import P from "components/P";
import ProgressbarSwiper from "components/swiper/ProgressBarSwiper";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { AuthContext } from "providers/AuthProvider";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import banner from "resources/img/avocado.jpg";
import logoLg from "resources/img/logo_lg.png";
import DummyCard from "routes/front/main/DummyCard";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import { rpad2D } from "shared/utils/Utils";
import { SwiperSlide } from "swiper/react";

function MobileHome() {
    const { isMobile } = useContext(BrowserDetectContext);
    const navigate = useNavigate();
    const [seletedCategory, setSeletedCategory] = useState("all");
    const [products, setProducts] = useState();
    const [cateogories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [isMounted, setMounted] = useState(false);
    const [filteredSubCategories, setFilteredSubCategories] = useState([]); // 하위카테고리
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [restockSlide, setRestockSlide] = useState([]);
    const { id } = useParams();
    const dispatch = useDispatch();
    const { userName } = useContext(AuthContext);


    useEffect(() => {
        setMounted(true);
    }, [])

    useEffect(() => {
        if (isMounted) {
            if (isMounted) {
                let data = { storeCode: id }
                requester.findAllVendorProducts(data, (result) => {
                    
                    setProducts(result.data);

                })
                requester.openfindAllCategory((result) => {
                    const sortedCategories = result.data.sort((a, b) => {
                        if (a.categoryName === '기기') return -1;
                        if (b.categoryName === '기기') return 1;
                        return 0;
                    });

                    if (sortedCategories.length > 0) {
                        // '기기' 카테고리를 초기 선택 상태로 설정
                        const selectedCategoryId = sortedCategories[0].id;
                        setSeletedCategory("");


                        // 기본 카테고리와 하위 카테고리 목록 설정
                        const filteredCategories = sortedCategories.filter(category => category.parentCategoryId == null);
                        setCategories(filteredCategories);

                        const filteredSubCategories = sortedCategories.filter(category => category.parentCategoryId != null);
                        setSubCategories(filteredSubCategories);


                        const filteredSubCategories2 = sortedCategories.filter(category =>
                            category.parentCategoryId === selectedCategoryId);
                        setFilteredSubCategories(filteredSubCategories2);


                        // 선택된 카테고리에 해당하는 하위 카테고리 ID들을 가져옴
                        const subCategoryIds = filteredSubCategories
                            .filter(sc => sc.parentCategoryId === selectedCategoryId)
                            .map(sc => sc.id);

                        // 선택된 카테고리 또는 그 하위 카테고리에 해당하는 상품들만 필터링
                        requester.findAllVendorProducts(data, (allProductsResult) => {
                            const filteredProducts = allProductsResult.data.filter(p =>
                                subCategoryIds.includes(p.categoryId) || p.categoryId === selectedCategoryId);
                            setRestockSlide(rpad2D(filteredProducts, isMobile ? 2 : 5, null));
                        });
                    }
                });
            }
        }
    }, [isMounted])


    const ProductCard = (props) => {
        const { data } = props;
        const onClickProduct = () => {
            
            navigate(`/ws/${id}/homepage/detail/${data.id}`, { state: { data: data } })
        }
        
        return (
            <div
                style={{
                    display: "flex",
                    flex: "1 1 23%",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "transperent",
                    padding: "20px 0",
                }}
                onClick={onClickProduct}
            >
                <div
                    style={{
                        borderRadius: "10px",
                        width: "93%",
                        padding: "10px",
                        boxShadow: "3px 2px 14.100000381469727px 0 rgba(254, 83, 31, 0.5)",
                    }}
                >
                    <VerticalFlex gap={10}>
                        <FlexChild>
                            <div
                                style={{
                                    padding: "10px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                                
                            >
                                <img src={data.productImg} width={"100%"} />
                            </div>
                        </FlexChild>
                        <FlexChild>
                            <Center>
                                <P ellipsis size={isMobile ? "1.7vw" : 15}>
                                    {data.productName}
                                </P>
                                <P size={20}>
                                    {data.price ? data.price.toLocaleString() : '가격 없음'}원
                                </P>
                            </Center>
                        </FlexChild>
                        {/* <FlexChild>
                            <HorizontalFlex gap={20}>
                                <FlexChild justifyContent={"flex-end"}>
                                    <P
                                        size={isMobile ? "1vw" : 10}
                                        borderRadius={"30px"}
                                        color={"white"}
                                        backgroundColor={"#EC4715"}
                                        padding={"7px 15px"}
                                        cursor={"pointer"}
                                        // onClick={orderClick}
                                    >
                                        구매하기
                                    </P>
                                </FlexChild>
                                <FlexChild justifyContent={"flex-start"}>
                                    <P
                                        size={isMobile ? "1vw" : 10}
                                        borderRadius={"30px"}
                                        border={"1px solid #EC4715"}
                                        color={"#EC4715"}
                                        padding={"5px 15px"}
                                        // onClick={addCartClick}
                                        cursor={"pointer"}
                                    >
                                        장바구니
                                    </P>
                                </FlexChild>
                            </HorizontalFlex>
                        </FlexChild> */}
                    </VerticalFlex>
                </div>
            </div>
        );
    };

    return (

        <Container maxWidth={1200}>
            <VerticalFlex>
                <FlexChild>
                    <img src={banner} width={"100%"} />
                </FlexChild>
                <FlexChild>
                    <VerticalFlex>
                        <FlexChild>
                            <Center width={"100%"} textAlign={"left"} padding={20}>
                                <P weight={"bold"} size={"min(2.2vw, 24px)"}>다양한 제품을 확인하세요!</P>
                            </Center>

                        </FlexChild>
                        <FlexChild padding={10}>
                            {
                                isMobile
                                    ?
                                    <ProgressbarSwiper totalSlides={restockSlide.length}>
                                        {
                                            restockSlide && restockSlide.map((slide, index) =>
                                                <SwiperSlide key={index}>
                                                    <HorizontalFlex gap={10}>
                                                        {
                                                            slide.map((product, index2) =>
                                                                <FlexChild key={index2} padding={"10px 0px"}>
                                                                    {
                                                                        product.id &&
                                                                        <ProductCard data={product} template={"normal"} />
                                                                    }

                                                                    {/* <MockItem index={41} /> */}
                                                                </FlexChild>)
                                                        }

                                                        {/* <Dummy height={"20px"} event /> */}
                                                    </HorizontalFlex >
                                                </SwiperSlide>
                                            )
                                        }
                                    </ProgressbarSwiper>


                                    :
                                    <div style={{ position: "relative" }}>
                                        <ProgressbarSwiper totalSlides={restockSlide.length}>
                                            {
                                                restockSlide && restockSlide.map((slide, index) =>
                                                    <SwiperSlide key={index}>
                                                        <HorizontalFlex gap={10}>
                                                            {
                                                                slide.map((product, index2) =>
                                                                    <FlexChild key={index2} padding={10}>
                                                                        {
                                                                            product.id &&
                                                                            <ProductCard data={product} template={"normal"} />
                                                                        }
                                                                        {/* <MockItem index={41} /> */}
                                                                    </FlexChild>)
                                                            }

                                                            {/* <Dummy height={"20px"} event /> */}
                                                        </HorizontalFlex >
                                                    </SwiperSlide>
                                                )
                                            }
                                        </ProgressbarSwiper>
                                    </div>
                            }
                        </FlexChild>
                        <FlexChild>
                            {/* <P size={"3.2vw"} weight={"bold"} color={"var(--main-color)"}>전자담배 전문매장</P> */}
                        </FlexChild>
                        <FlexChild>
                            <img src={logoLg} />
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
}

export default MobileHome;